import React, { Component } from 'react';
import Dropdown from 'rc-dropdown';
import Menu, { Item as MenuItem } from 'rc-menu';
import 'rc-dropdown/assets/index.css';
import ProcessPicker from './ProcessPicker/ProcessPicker';

class ProcesosDropdown extends Component {

    constructor(props) {
        super(props);
        this.state = { filaElegida: this.props.procesos.length };
    }

    cambiarFila(proceso) {
        this.props.filtrarFn(proceso);
        this.setState({ filaElegida: proceso.id });
    }

    render() {

        const { procesos, filtrarFn, cambiarRangoPagina, rangoIndex } = this.props;

        if (procesos.length == 0)
            return (
            <button className="ProcesosDropdownButton btn btn-default disabled" type="button">
               Sin fechas procesadas
            </button>    
            );

        const { filaElegida } = this.state;
        const procesosDisponibles = procesos.map((p) => {
            return {
              id: p.Id,
              numero: p.Id,
              fecha: p.FechaRespuesta.split('T')[0]
            }
        });               

        const procesoElegido = procesosDisponibles.find(p => p.id === filaElegida);
        const { numero, fecha } = (procesoElegido == undefined ? procesosDisponibles[0] : procesoElegido);

        const menu = (
        <Menu onSelect={() => { }} selectedKeys={[]} className="DeliveryTarjetas-MenuDropdownProcesosContainer">
            <ProcessPicker
                    procesos={procesosDisponibles}
                    filtrarFn={filtrarFn}
                    cambiarFila={this.cambiarFila.bind(this)}
                    filaElegida={filaElegida}
                    cambiarRangoPagina={cambiarRangoPagina}
                    rangoIndex={rangoIndex}
            />
        </Menu>
        );

        return (
        <Dropdown
            trigger={['click']}
            overlay={menu}
            animation="slide-up"            
        >
            <button className="btn btn-default ProcesosDropdownButton" type="button">
                <span className="ti-calendar"></span>
                &nbsp; <span className="ProcesoText">{numero}</span>&nbsp; ({fecha})
            </button>
        </Dropdown>
        );

    }

}

export default ProcesosDropdown;
